import ModalManager from "@/components/ModalComponent/ModalManager";
import i18n from "@/i18n";
import BFButton from "@/modules/abstract-ui/general/Button/BFButton";
import DataBusDefaults from "@/services/DataBusDefaults";
import React from "react";

const VacancyContractCancelButton = () => {
  return (
    <BFButton
      appearance="outline"
      onClick={() => {
        // 1. are you sure modal
        ModalManager.confirm({
          title: i18n.t(
            "apTemplate:Vacancy.Applicant.Contract.Label.CancelTitle",
            "Vertragserstellung abbrechen"
          ),
          message: i18n.t(
            "apTemplate:Vacancy.Applicant.Contract.Label.CancelMessage",
            "Sind Sie sicher, dass Sie die Bearbeitung des Vertrags abbrechen möchten? Alle eingegebenen Daten gehen dabei verloren."
          ),
          confirmButtonText: i18n.t(
            "apTemplate:Vacancy.Applicant.Contract.Label.CancelConfirmBtn",
            "Vertragserstellung abbrechen"
          ),
          cancelButtonText: i18n.t(
            "apTemplate:Vacancy.Applicant.Contract.Label.CancelCancelBtn",
            "Nicht abbrechen"
          ),
          onConfirm: () => {
            setTimeout(() => {
              DataBusDefaults.closeAllModals();
            }, 300);
          },
        });
      }}
    >
      {i18n.t(
        "apTemplate:Vacancy.Applicant.Contract.Label.Cancel",
        "Abbrechen"
      )}
    </BFButton>
  );
};

export default VacancyContractCancelButton;
